import { useEffect, useState } from "react";

const tickerItems = [
  "Hotels",
  "Apartment Rentals",
  "Campsite",
  "Restaurants & Cafés",
  "Bars / Nightlife",
  "Fitness Clubs / Academies",
  "Spa & Wellness Clinics",
  "Golf Course",
];

export function SolutionsTicker() {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    setPrefersReducedMotion(mediaQuery.matches);

    const handler = (e: MediaQueryListEvent) => setPrefersReducedMotion(e.matches);
    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  // Create repeated items for seamless loop (4x for smooth continuous scroll)
  const repeatedItems = [...tickerItems, ...tickerItems, ...tickerItems, ...tickerItems];

  const renderTickerContent = () => (
    <>
      {repeatedItems.map((item, index) => (
        <span key={index} className="inline-flex items-center whitespace-nowrap">
          <span className="text-white/90 text-[13px] sm:text-sm font-medium tracking-wide">
            {item}
          </span>
          <span className="mx-5 sm:mx-8 text-white/30 text-[10px]">•</span>
        </span>
      ))}
    </>
  );

  return (
    <div 
      className="relative w-full overflow-hidden"
      style={{ 
        background: "linear-gradient(180deg, rgba(30, 41, 59, 0.6) 0%, rgba(30, 41, 59, 0.4) 100%)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
      }}
    >
      {/* Subtle top border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      
      {/* Subtle bottom border */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      
      {/* Soft shadow overlay */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          boxShadow: "inset 0 1px 0 rgba(255,255,255,0.05), 0 4px 20px -4px rgba(0,0,0,0.15)",
        }}
      />

      <div
        className="h-[56px] sm:h-[60px] flex items-center"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {prefersReducedMotion ? (
          // Static horizontal scroll for reduced motion
          <div 
            className="flex items-center overflow-x-auto scrollbar-hide px-6 w-full"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {tickerItems.map((item, index) => (
              <span key={index} className="inline-flex items-center whitespace-nowrap flex-shrink-0">
                <span className="text-white/90 text-[13px] sm:text-sm font-medium tracking-wide">
                  {item}
                </span>
                {index < tickerItems.length - 1 && (
                  <span className="mx-5 sm:mx-8 text-white/30 text-[10px]">•</span>
                )}
              </span>
            ))}
          </div>
        ) : (
          // Animated ticker - smooth, slow, linear
          <div
            className="flex items-center ticker-track-premium"
            style={{
              animationPlayState: isPaused ? "paused" : "running",
            }}
          >
            {renderTickerContent()}
            {renderTickerContent()}
          </div>
        )}
      </div>

      <style>{`
        @keyframes ticker-scroll-premium {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-25%);
          }
        }
        
        .ticker-track-premium {
          animation: ticker-scroll-premium 35s linear infinite;
          will-change: transform;
        }
        
        @media (max-width: 640px) {
          .ticker-track-premium {
            animation-duration: 25s;
          }
        }
        
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
}
